module.exports = __webpack_public_path__ + "static/img/store.acaa2fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/store.png
// module id = y2zH
// module chunks = 1